<script>
    import geos from "../stores/geos";
    import GeoItem from "./GeoItem.svelte";
    import {
        scrollToElement,
        findNode,
        searchNodes,
        backPath,
        upCaseStr,
        getParentNodes,
        expandParents,
        findNodeParentOfLevel,
        collapseAll,
        setFocusTo,
        JSONClone
    } from "../lib/lib";
    import {geosLoad, geoDelete} from "../lib/requests";
    import app_alert from "../stores/alerts";
    import success from '../stores/success';
    import error from '../stores/error';
    import GeoModal from "./GeoModal.svelte";
    import {loop_guard} from "svelte/internal";

    let geoSearchTerm = '';
    let oldSearchTerm = '';
    let searchResults = [];
    let searchIndex = null;
    let onRegionSearch = true;
    let oldSelectedId = null;
    let selectedGeoParentPath = "";
    let matchSource = 0;

    let editedGeo = null;

    const resetNode = (node) => {
        node.map(item => {
            item.geo_matches = null;
            if (item.children.length) {
                Initialize(item.children);
            }
        });
    }

    const Initialize = (list = null) => {
        // Initialize all tree items
        let resetTree = false;
        if (!list) {
            list = $geos.tree;
            resetTree = true;
        }
        list.map(item => {
            item.geo_matches = null;
            if (item.children.length) {
                Initialize(item.children);
            }
        });
        if (resetTree) {
            $geos.tree = $geos.tree;
        }
    }

    const onSearch = (event) => {
        if (event.key === 'Enter') {
            if (oldSearchTerm !== geoSearchTerm) {
                resetSearch();
                if (geoSearchTerm.length > 0) {

                    if (!isNaN(geoSearchTerm)) {
                        // if search term is a location id
                        searchResults = [];
                        let node = findNode(geoSearchTerm, $geos.tree);
                        if (node) {
                            searchResults.push(node.id);
                        }
                    } else {
                        // if search term is a string
                        let tree = $geos.tree;
                        if (onRegionSearch && $geos.selected_id > 0) {
                            // get node parent region
                            let region = findNodeParentOfLevel($geos.selected_id, 0, tree);
                            if (region) {
                                tree = region.children;
                            }
                        }

                        // put "Άνω" and "Κάτω" first
                        geoSearchTerm = geoSearchTerm.trim();
                        let arr = geoSearchTerm.split(" ");
                        if (arr.length) {
                            let lastWord = arr[arr.length - 1];
                            if (lastWord === "Επάνω" || lastWord === "Άνω" || lastWord === "Κάτω") {
                                arr.unshift(lastWord);
                                arr.pop();
                                geoSearchTerm = arr.join(' ');
                            }
                        }

                        searchResults = searchNodes(upCaseStr(geoSearchTerm), tree);
                    }

                    oldSearchTerm = geoSearchTerm;
                    if (searchResults.length === 0) {
                        error.show("Δεν βρέθηκαν αποτελέσματα");
                    } else {
                        $geos.last_selected_id = $geos.selected_id;
                    }
                }
            }
            showNextSearchResult();
        } else if (event.key === 'Escape') {
            geoSearchTerm = '';
            resetSearch();
        }
    }

    const resetSearch = () => {
        oldSearchTerm = '';
        searchResults = [];
        searchIndex = null;
        $geos.marked_id = 0;
    }

    const showNextSearchResult = () => {
        if (searchResults.length > 0) {
            if (searchIndex === null) {
                searchIndex = 0;
            } else {
                searchIndex++;
                if (searchIndex > searchResults.length - 1) {
                    searchIndex = 0;
                }
            }

            $geos.marked_id = searchResults[searchIndex];
            gotoLocation(searchResults[searchIndex], false);
        }
    }

    const gotoLocation = (id, collapse_expanded = true) => {
        let node = findNode(id, $geos.tree);
        if (!node) {
            return;
        }
        let parents = getParentNodes(node, $geos.tree);
        parents.map(item => {
            item.expanded = true;
        });
        $geos.selected_id = id;
        if (collapse_expanded) {
            onCollapseAll();
        }
        $geos.tree = $geos.tree;
        scrollToElement('geo-item-' + id);
    }

    const toggleSearchScope = () => {
        onRegionSearch = !onRegionSearch;
        resetSearch();
    }

    const anOtherIsEdited = () => {
        if ($geos.edit_id !== null) {
            app_alert.show('error', "Έχετε ήδη ανοιχτή μια τοποθεσία για επεξεργασία");
            return true;
        }
        return false;
    }

    const noneSelected = () => {
        if ($geos.selected_id === 0) {
            app_alert.show('error', "Δεν έχετε επιλέξει περιοχή!");
            return true;
        }
        return false;
    }

    const getSelected = () => {
        let geo = findNode($geos.selected_id, $geos.tree);
        if (!geo) {
            app_alert.show('error', `Δεν βρέθηκε περιοχή με id ${$geos.selected_id}!`);
        }
        return geo;
    }


    const onAdd = () => {
        if (anOtherIsEdited()) {
            return;
        }
        if (noneSelected()) {
            return;
        }

        let geo = getSelected();
        if (!geo) {
            return;
        }

        if (geo.level > 3) {
            app_alert.show('error', `Δεν μπορείτε να προσθέσετε υποπεριοχές εδώ!`);
            return;
        }

        editedGeo = {
            id: 0,
            parent_id: geo.id,
            level: parseInt(geo.level) + 1,
            name_el: '',
            name_en: '',
            slug: '',
            latlng: '',
            deprecated: 0,
            children: [],
        };
    }

    const onEdit = (data) => {
        if (anOtherIsEdited()) {
            return;
        }
        if (noneSelected()) {
            return;
        }

        if (!data) {
            editedGeo = JSONClone(findNode($geos.selected_id, $geos.tree));
            return;
        }

        editedGeo = JSONClone(data.detail);
    }

    const closeEdit = data => {
        editedGeo = null;

        if (data) {
            let parent = null;

            let node = findNode(data.id, $geos.tree);
            if (!node) {
                // new geo
                parent = findNode(data.parent_id, $geos.tree);
                parent.children = [...parent.children, data];
            } else {
                if (data.parent_id !== node.parent_id) {
                    // remove geo from parent
                    parent = findNode(node.parent_id, $geos.tree);
                    parent.children = parent.children.filter(x => x.id !== data.id);
                    // add geo on new parent
                    parent = findNode(data.parent_id, $geos.tree);
                    parent.children = [...parent.children, data];
                }
                node.parent_id = data.parent_id;
                node.name_el = data.name_el;
                node.name_en = data.name_en;
                node.slug = data.slug;
                node.level = data.level;
                node.latlng = data.latlng;
                node.old_id = data.old_id;
                node.is_deprecated = data.is_deprecated;
            }
            $geos.tree = $geos.tree;
            expandParents($geos.selected_id, $geos.tree);
        }
    }


    const onDelete = () => {
        if (anOtherIsEdited()) {
            return;
        }

        if (noneSelected()) {
            return;
        }
        let geo = getSelected();
        if (!geo) {
            return;
        }

        if (geo.level < 2) {
            app_alert.show('error', "Δεν μπορείτε να διαγράψετε γεωγραφικό διαμέρισμα ή νομό!");
            return;
        }

        if (geo.children.length > 0) {
            app_alert.show('error', "Δεν μπορείτε να διαγράψετε τοποθεσία με υποπεριοχές!");
            return;
        }

        app_alert.show('confirm', `Να διαγραφεί η περιοχή "${geo.name_el}";`, async () => {

            const [err, res] = await geoDelete(geo.id);

            if (err) {
                alert(err);
                return;
            }

            // find node parent
            let parent = findNode(geo.parent_id, $geos.tree);
            if (parent) {
                parent.children = parent.children.filter(x => x.id !== geo.id);
            }
            $geos.selected_id = 0;
            $geos.tree = $geos.tree;

            success.show("Η περιοχή διαγράφτηκε.");
        });
    }

    const Load = async () => {
        const [err, res] = await geosLoad();

        if (err) {
            alert('error ' + err)
            return;
        }

        $geos.tree = res.tree;

        if ($geos.selected_id === 0 && res.last_selected_id > 0) {
            $geos.selected_id = res.last_selected_id;
        }

        if ($geos.selected_id > 0) {
            expandParents($geos.selected_id, $geos.tree);
        }
    }

    const onCollapseAll = () => {
        collapseAll($geos.tree, $geos.selected_id);
        $geos.tree = $geos.tree;
        scrollToElement('geo-item-' + $geos.selected_id);
    }

    const onGotoLastSelected = () => {
        $geos.selected_id = $geos.last_selected_id;
        scrollToElement('geo-item-' + $geos.selected_id);
    }

    $: {
        if (matchSource !== !$geos.match_source) {
            matchSource = $geos.match_source;
            Initialize();
        }
        if (oldSelectedId === null && $geos.selected_id > 0) {
            oldSelectedId = 0;
            expandParents($geos.selected_id, $geos.tree);
        }
        if (oldSelectedId !== $geos.selected_id) {
            oldSelectedId = $geos.selected_id;
            selectedGeoParentPath = backPath($geos.selected_id, $geos.tree);
        }
        if ($geos.search_term) {
            geoSearchTerm = $geos.search_term;
            $geos.search_term = '';
            onSearch({key: 'Enter'});
        }
        if (!geoSearchTerm && oldSearchTerm) {
            resetSearch();
        }
    }
</script>

<div class="section-header">
    <div class="row">
        <div class="col-md-8">
            <button class="btn btn-primary" title="Νέα τοποθεσία" on:click="{ onAdd }"><i class="fa fa-plus"></i>
            </button>
            <button class="btn btn-primary" title="Επεξεργασία επιλεγμένης" on:click="{() => onEdit() }"><i
                    class="fa fa-edit"></i></button>
            <button class="btn btn-primary" on:click="{ onDelete }" title="Διαγραφή επιλεγμένης"><i
                    class="fa fa-remove"></i></button>
            <span class="separator"></span>
            <button class="btn btn-primary" on:click="{ onCollapseAll }" title="Κατάρρευση όλων"><i
                    class="fa fa-toggle-up"></i></button>
            <span class="separator"></span>
            <button class="btn btn-primary" on:click="{ Load }" title="Ανανέωση περιοχών"><i class="fa fa-refresh"></i>
            </button>
        </div>
        <div class="col-md-4">
            <div class="form-inline text-right">
                <button class="btn btn-primary" title="αναζήτηση στον νομό" on:click="{ toggleSearchScope }">
                    {#if onRegionSearch}
                        <i class="fa fa-map"></i>
                    {:else}
                        <i class="fa fa-map-o"></i>
                    {/if}
                </button>
                <input type="text" class="form-control" bind:value="{ geoSearchTerm }" on:keyup="{ onSearch }"
                       placeholder="αναζήτηση">
                <button class="btn btn-primary" title="επιστροφή στην αρχική επιλογή" on:click="{ onGotoLastSelected }">
                    <i class="fa fa-arrow-left"></i></button>
            </div>
        </div>
    </div>
</div>

<div class="panel">
    <div class="panel-heading">
        <h2>Geos</h2>
        <h6>{ selectedGeoParentPath }</h6>
    </div>
    <div class="panel-body fixed-height">
        <div class="panel-body-inner">
            {#each $geos.tree as geo}
                <GeoItem geo="{ geo }" on:edit="{ onEdit }"/>
            {/each}
        </div>
    </div>
</div>

{#if editedGeo != null}
    <GeoModal modalMd geo={editedGeo} closeCallback={closeEdit}/>
{/if}
